// import profileAvatar from "../../assets/images/header/Ellipse_73@2x.png";
// import editIcon from "../../assets/images/profile/edit_icon.svg";
import editIcon from "../../assets/images/icons/edit.svg";
import Followings from "../followers/followers";
import StateDropDown from "../state-dropdown/stateDropDown";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import {
  TextField,
  Input,
  Typography,
  Button,
  Fade,
  Modal,
  Box,
  Backdrop,
  Grid,
  Paper,
} from "@mui/material";
import Masonry from "@mui/lab/Masonry";
import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./index.scss";
import UploadBtn from "../upload-button/uploadBtn";
import validator from "validator";
import defaultAvatar from "../../assets/images/profile/default_avatar.png";
import tossball from "../../assets/images/rewards/tossball.png";
import threedot from "../../assets/images/icons/threedot.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "../loading-button/LoadingButton";
import { useRef } from "react";
import Posts from "../posts";
import useScroller from "../../commons/useScroller.js";
import { BallTriangle } from "react-loader-spinner";
import FollowerPanel from "./get-follower";
import FollowingPanel from "./get-following";
import BGImage from "../../assets/images/profile/bg.jpg";
import BlockUserImage from "../../assets/images/home/blockuser.png";
import Logo from "../../assets/images/home/logo/logo@2x.png";
import Run from "../posts/run";
import SubmenuInLine from "../submenu_inline/index";
import Post from "../posts/post";
import UserCard from "../followers/followers";
import ProfileList from "../../commons/components/ProfileList";
import {
  clearStorage,
  getStorageItem,
  setStorageItem,
} from "../../utils/sessionStorage";
import ImageModal from "../../commons/components/image-modal";
import { Helmet } from "react-helmet";
import ProfileDropdown from "./ProfileDropdown";
import About from "./About/About";
import { useDispatch, useSelector } from "react-redux";
import { PathAction } from "../../redux/reducers/globalPath";

import { ParaglidingTwoTone } from "@mui/icons-material";
const loggedUserId = getStorageItem("user_id");

const styleDesktop = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#FFFFFF",
  border: "2px solid #000",
  borderRadius: "20px",
  boxShadow: 24,
  py: 1,
  px: 4,
};

const styleMobile = {
  position: "absolute",
  width: "90%",
  bgcolor: "#FFFFFF",
  boxShadow: 24,
  py: 1,
  px: 4,
  height: "100%",
  width: "100%",
};

const buttonMobile = {
  borderRadius: 2,
  width: "70%",
  height: "35px",
  // m: "2.5%",
  backgroundColor: "transparent",
  border: "1px solid",
  // mt: "18px",
  color: "white",
  display: "flex",
  alignItems: "flex-start",
  minWidth: "136px",
  // maxWidth: "100%"
};

const buttonDesktop = {
  borderRadius: 2,
  width: "70%",
  height: "35px",
  m: "2.5%",
  backgroundColor: "transparent",
  border: "1px solid",
  mt: "18px",
  color: "white",
  display: "flex",
  alignItems: "flex-start",
  minWidth: "136px",
  // maxWidth: "100%"
};

const Profile = ({ handlecoverPhoto, Params }) => {
  const [style, setStyle] = useState();
  const [coverid, setCoverid] = useState("");
  const [profileRole, setProfileRole] = useState("");
  const [profiledropOpen, setProfiledrop] = useState(false);
  const [OpenPostAbout, setOpenPostAbout] = useState(true);
  const [profileInitialData, setProfileInitialData] = useState({
    first_name: "",
    last_name: "",
    full_name: "",
    address: "",
    address2: "",
    zip_code: "",
    state: "",
    about_me: "",
    email: getStorageItem("user_email"),
    avatar: defaultAvatar,
    followersCount: 0,
    followingCount: 0,
    totalRun: 0,
    gender: "",
    country: "",
    countryFlag: "",
    DOB: "",
    showDob: false,
  });
  const [followers, setFollowers] = useState([]);
  const [followings, setFollowings] = useState([]);
  const [avatar, setAvatar] = useState("");
  const [avatarFile, setAvatarFile] = useState();
  const navigate = useNavigate();
  const accessToken = getStorageItem("token");
  const localStorageUserId = getStorageItem("user_id");

  let canEditProfile = true;
  const matches = useMediaQuery("(min-width:600px)");
  const mobile = useMediaQuery("(max-width: 460px)");
  const [profileInfo, setProfileInfo] = useState([]);
  const [ownProfile, setOwnProfile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isFollowing, setIsFollowing] = useState(false);
  const [buttonValue, setButtonValue] = useState("Loading..");
  const [ownFollowings, setOwnFollowings] = useState([]);
  const [buttonStyle, setButtonStyle] = useState({});
  const timer = useRef();
  const [followingPanel, setFollowingPanel] = useState(false);
  const [selectedSubmenu, setSelectedSubmenu] = useState("mypost");
  const [nameSearchResults, setNameSearchResults] = useState([]);
  const [Followed, setFollwed] = useState(false);
  const [Block, setBlock] = useState(false);
  const PitchCountFromRedux = useSelector((state) => state.path.PostCount);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  if (Params) {
    canEditProfile = false;
  }

  if (Params === loggedUserId) {
    canEditProfile = true;
  }

  const fetchOwnFollowing = () => {
    if (!accessToken) return;
    const getOwnFollowing = {
      method: "GET",
      url: global.config.ROOTURL.prod + "/auth/get-following-user-id/",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    axios(getOwnFollowing)
      .then((response) => {
        setOwnFollowings(response.data ? response.data : []);
      })
      .then(() => checkFollower())
      .catch((error) => {
        if (error?.response?.status === 401) {
          clearStorage();
          navigate("/login");
        }
      });
  };

  const fetchUserInfo = (id) => {
    if (!id && !accessToken) return;
    const getUserInfo = {
      method: "POST",
      url: global.config.ROOTURL.prod + "/auth/profile/",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      data: {
        userId: id,
      },
    };
    axios(getUserInfo)
      .then((response) => {
        setStorageItem("coverPhotoid", response?.data?.coverphoto);
        handlecoverPhoto(response.data.coverphoto);
        setCoverid(response.data.coverphoto);
        dispatch(
          PathAction.handlePostCount({ payload: response?.data?.pitchCount })
        );
        setProfileInitialData({
          first_name: response.data.firstName ? response.data.firstName : "",
          last_name: response.data.lastName ? response.data.lastName : "",
          full_name: response.data.firstName + " " + response.data.lastName,
          address: "",
          address2: "",
          zip_code: "",
          state: response.data.state ? response.data.state : "",
          about_me: response.data.aboutMe ? response.data.aboutMe : "",
          gender: response.data.Gender ? response.data.Gender : "",
          country: response.data.Country ? response.data.Country : "",
          countryFlag: response.data.countryFlag
            ? response.data.countryFlag
            : "",
          DOB: response.data.DOB ? response.data.DOB : "",
          showDob: response.data.showDob,
          email: response.data.email ? response.data.email : "",
          avatar: response.data.profilePhoto ? response.data.profilePhoto : "",
          followingCount: response.data.followingCount
            ? response.data.followingCount
            : 0,
          followersCount: response.data.followersCount
            ? response.data.followersCount
            : 0,
          totalRun: response.data.totalRun ? response.data.totalRun : 0,
          pitchCount: response.data.pitchCount ? response.data.pitchCount : 0,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          clearStorage();
          navigate("/login");
        }
      });
  };

  const handleUnfollow = () => {
    if (!Params && !accessToken) return;
    const unfollow = {
      method: "POST",
      url: global.config.ROOTURL.prod + "/auth/remove-following-user/",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      data: {
        followingUserId: Params,
      },
    };

    if (Params != null) {
      axios(unfollow)
        .then(() => setIsFollowing(false))
        .catch((error) => {
          if (error?.response?.status === 401) {
            clearStorage();
            navigate("/login");
          }
        });
    }
  };

  const handleFollow = () => {
    if (!Params && !accessToken) return;
    const follow = {
      method: "POST",
      url: global.config.ROOTURL.prod + "/auth/add-following-user/",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      data: {
        followingUserId: Params,
      },
    };

    if (Params != null) {
      axios(follow)
        .then(() => setIsFollowing(true))
        .catch((error) => {
          if (error?.response?.status === 401) {
            clearStorage();
            navigate("/login");
          }
        });
    }
  };

  const checkFollower = () => {
    if (ownFollowings?.length > 0) {
      for (let i = 0; i < ownFollowings.length; i++) {
        if (Params == ownFollowings[i]?._id) {
          setIsFollowing(true);
        }
      }
    }
  };
  const handleOpenPOstAbout = () => {
    setOpenPostAbout(!OpenPostAbout);
  };

  const handleDropdown = () => {
    setProfiledrop(!profiledropOpen);
  };

  useEffect(() => {
    if (!matches) {
      setStyle(styleMobile);
      setButtonStyle(buttonMobile);
    } else {
      setStyle(styleDesktop);
      setButtonStyle(buttonDesktop);
    }
  }, [matches]);

  useEffect(() => {
    setOpenPostAbout(true);
    fetchOwnFollowing();
    if (Params === getStorageItem("user_id")) {
      setOwnProfile(true);
    }
    if (!Params) {
      setOwnProfile(true);
    }
    fetchUserInfo(Params);
    getBlockuserList();
  }, [Params]);

  const handleupdateblockuser = () => {
    setBlock(true);
  };
  const hanldeunblockuser = () => {
    setBlock(false);
  };

  const checkblockUser = (blocklist) => {
    const isblock = blocklist.filter((i) => i.blockedUserId == Params);
    if (isblock.length > 0) {
      setBlock(true);
    }
  };
  const getBlockuserList = () => {
    if (!Params && !accessToken) return;
    const getList = {
      method: "POST",
      url:
        global.config.ROOTURL.prod + "/auth/block/get-blocked-users-by-userID",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      data: {
        blockUserId: Params,
      },
    };

    if (Params != null) {
      axios(getList)
        .then((res) => {
          console.log(res, "block");
          setBlock(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  useEffect(() => { }, [PitchCountFromRedux]);

  useEffect(() => {
    getBlockuserList();
  }, [Block]);

  useEffect(() => {
    checkFollower();
  }, [ownFollowings]);

  return (
    <>
      <div>
        <Helmet>
          <title>Champhunt | Profile</title>
        </Helmet>
        {/* profile contaner  */}
        <div className="profile_container">
          <div className="img_container">
            <div>
              <img
                src={
                  profileInitialData?.avatar
                    ? profileInitialData?.avatar
                    : defaultAvatar
                }
                className="margintopProfile"
                onClick={() => handleOpen()}
              />
            </div>
            <p className="Font16Px">{profileInitialData?.full_name}</p>
          </div>
          <img src={threedot} onClick={handleDropdown} />

          {/* if its not ownPofile then this component trigger  */}
          {profiledropOpen && (
            <ProfileDropdown
              userId={Params}
              userName={
                profileInitialData.first_name +
                " " +
                profileInitialData.last_name
              }
              Block={Block}
              hadleUserBlockToparent={handleupdateblockuser}
              hanldeunblockuser={hanldeunblockuser}
              ownProfile={ownProfile}
            />
          )}
        </div>

        {/* follow button container  */}

        <div className="follow1_container">
          {!ownProfile && !isFollowing && (
            <Button
              className="fierstButton"
              style={{ marginRight: "24px" }}
              onClick={handleFollow}
            >
              follow
            </Button>
          )}
          {!ownProfile && isFollowing && (
            <Button
              className="fierstButton"
              style={{ marginRight: "24px" }}
              onClick={handleUnfollow}
            >
              Unfollow
            </Button>
          )}

          <Button className="secoundButton">
            <div className="displayflexCommonClass">
              <img src={tossball} />
              <p className="runStyle">{profileInitialData.totalRun} </p>
            </div>
          </Button>
          {ownProfile && (
            <Button
              className="secoundButton"
              style={{ marginLeft: "24px" }}
              onClick={() => {
                navigate(`/profile_edit`);
              }}
            >
              {" "}
              Edit
            </Button>
          )}
          {/* {ownProfile && (
            <Button
              className="secoundButton"
              style={{ marginLeft: "24px" }}
              onClick={() => {
                navigate(`/advertisments/${Params}`);
              }}
            >
              {" "}
              Advertisments
            </Button>
          )} */}
        </div>
        {/* Post,folow count container  */}
        <div>
          <div className="MainPostContainer">
            <div className="childContainer">
              <p style={{ cursor: "pointer", textDecoration: "underline", color: "#0C5BA0" }}>Posts</p>
              <p className="underline-hover">{PitchCountFromRedux} </p>
            </div>

            <div className="childContainer" onClick={() => navigate(`/followers-page/${Params}`)}>
              <p style={{ cursor: "pointer", textDecoration: "underline", color: "#0C5BA0" }}>
                Followers
              </p>
              <p className="underline-hover">{profileInitialData.followersCount} </p>
            </div>


            <div className="childContainer" onClick={() => navigate(`/following-page/${Params}`)}>
              <p style={{ cursor: "pointer", textDecoration: "underline", color: "#0C5BA0" }}>
                Following
              </p>
              <p className="underline-hover">{profileInitialData.followingCount} </p>
            </div>
          </div>
          <hr style={{ marginTop: "10px" }} />
        </div>

        {/* post and About conatiner  */}

        <div className="PostAboutContainer">
          <div
            className="childContainer"
            style={{ borderRight: "1px solid #D9D9D9" }}
            onClick={handleOpenPOstAbout}
          >
            <p className={OpenPostAbout ? "active_container" : ""}
            >
              {" "}
              Posts
            </p>
          </div>
          <div className="childContainer" onClick={handleOpenPOstAbout}>
            <p
              className={!OpenPostAbout ? "active_container" : ""}              
            >
              {" "}
              About Me
            </p>
          </div>
        </div>

        {/* Container that hold  Posts and About  */}

        {/* if you are block then this container  */}

        {Block ? (
          <Grid container className="block_image_place">
            <img src={Logo} className="block_logo" />
            <div className="block_image">
              <img src={BlockUserImage} style={{ width: "100px" }} />
              <p className="block_para">
                To see their pitches and runs you need to Unblock them.
              </p>
            </div>
          </Grid>
        ) : OpenPostAbout ? (
          <ProfileList userId={Params} page="profile" />
        ) : (
          <About userData={profileInitialData} />
        )}

        {/* Modals  */}

        <ImageModal
          avatar={profileInitialData?.avatar}
          open={open}
          handleClose={handleClose}
        />
      </div>
    </>
  );
};

export default Profile;
